import { Component, ViewEncapsulation } from "@angular/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
  isLogin: boolean = true;
  constructor() {}
  title = "OAT";
  ngOnInit(): void {
  }
  ngOnDestroy(): void {
  }
}